export const messageStatusEnum = Object.freeze({
	pending: 'pending',
	sent: 'sent',
	delivered: 'delivered',
	read: 'read',
	failed: 'failed',
});

export const interactiveSubtypes = Object.freeze({
	Catalog: 'catalog_message',
	PaymentSummary: 'cta_url',
	Product: 'product',
	Products: 'product_list',
	InteractiveButtons: 'button',
	ButtonReply: 'button_reply',
	Flow: 'flow',
	nfmReply: 'nfm_reply',
	List: 'list',
	ListReply: 'list_reply',
});

export const messageTypeEnum = Object.freeze({
	Text: 'text',
	Interactive: 'interactive',
	Document: 'document',
	Image: 'image',
	Video: 'video',
	Audio: 'audio',
	Location: 'location',
	Order: 'order',
	Template: 'template',
	Button: 'button',
	Sticker: 'sticker',
	Log: 'log',
	// Custom Types:
	PaymentResponse: 'payment_response',
	ProductReplied: 'product_replied',
});

export const logActionEnum = Object.freeze({
	Escalation: 'Escalation',
	AssignToUser: 'AssignToUser',
	UnassignToUser: 'UnassignToUser',
	DisableAI: 'DisableAI',
	EnableAI: 'EnableAI',
});
